import UpgradeAction from '@/classes/SubmissionActions/UpgradeAction'
import { BaseEverplansStatus } from '@/classes/SubmissionStatuses/BaseEverplansStatus'
import { StatusThemeVariant } from '@/classes/SubmissionStatuses/StatusThemeVariantEnum'
import { getEverplansTierText } from '@/classes/SubmissionStatuses/statusUtils'
import { type SubmissionAction } from '@/classes/SubmissionStatuses/types'

export class SuccessStatus extends BaseEverplansStatus {
	getActions(): Array<SubmissionAction> {
		if (this.submissionStatus.accountTier !== 'premium') {
			return [new UpgradeAction()]
		}
		return []
	}

	getStatusText() {
		return getEverplansTierText(this.submissionStatus.accountTier)
	}

	getToolTipText() {
		const body =
			this.submissionStatus.accountTier === 'premium'
				? 'This packet submitted successfully to ' + this.getVendorName() + '.'
				: 'This packet submitted successfully to ' +
					this.getVendorName() +
					'. If the family wants to upgrade to Lifetime, please click the Upgrade button.'

		return {
			title: this.getVendorName() + ' ' + this.getStatusText(),
			body,
		}
	}

	getThemeVariant() {
		return StatusThemeVariant.SUCCESS
	}
}
